import { color } from 'framer-motion';
import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";
const discounts = [10, 20, 25, 50];
const itemsList = [
 "Denim Jacket", "Sneakers", "Summer Dress", "Leather Bag",
      "Wool Sweater", "Scarf Set", "T-shirt Pack", "Jeans",
      "Raincoat", "Hoodie"
];

const getRandomItem = () => {
  const item = itemsList[Math.floor(Math.random() * itemsList.length)];
  const price = Math.floor(Math.random() * 40 + 10); // $10 to $50
  const discount = discounts[Math.floor(Math.random() * discounts.length)];
  return { name: item, price, discount };
};

const MagicMallMarkdown = () => {
  const [items, setItems] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [result, setResult] = useState('');
  const [showNext, setShowNext] = useState(false);

  const generateScenario = () => {
    const newItems = Array.from({ length: 4 }, () => getRandomItem());
    setItems(newItems);
    setInputs(Array(4).fill(''));
    setResult('');
    setShowNext(false);
  };

  const handleInputChange = (value, index) => {
    const updatedInputs = [...inputs];
    updatedInputs[index] = value;
    setInputs(updatedInputs);
  };

  const checkAnswers = () => {
    let allCorrect = true;
    let feedback = '';

    items.forEach((item, i) => {
      const userInput = parseFloat(inputs[i]);
      const discountAmount = item.price * (item.discount / 100);
      const finalPrice = parseFloat((item.price - discountAmount).toFixed(2));

      if (userInput === finalPrice) {
        feedback += `✅ ${item.name}: Correct!<br>`;
      } else {
        feedback += `❌ ${item.name}: Should be $${finalPrice}<br>`;
        allCorrect = false;
      }
    });

    setResult(feedback);
    setShowNext(allCorrect);
    if(allCorrect){
         const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }
  };

  useEffect(() => {
    generateScenario();
  }, []);

  const styles = {
    body: {
      margin: 0,
      fontFamily: "'Comic Sans MS', cursive, sans-serif",
      backgroundImage: "url('https://media.istockphoto.com/id/1448501388/video/mathematical-formulas-maths.jpg?s=640x640&k=20&c=a47K0BJ3yFwAdu_YDZNmQfB-5lj_ltA2UKJRWxFFNso=')",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      color: "#fff",
      minHeight: "100vh",
    },
    // overlay: {
    //   backgroundColor: "rgba(170, 167, 167, 0.7)",
    //   padding: "2rem 1rem",
    //   minHeight: "100vh",
    //   boxSizing: "border-box"
    // },
    heading: {
      textAlign: "center",
      color: "#ffd54f",
      fontSize: "clamp(2rem, 5vw, 3rem)",
    },
    itemContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      gap: "20px",
      justifyContent: "center",
      marginTop: "30px",
    },
    item: {
      background: "#6a1b9a",
      border: "2px solid #ab47bc",
      borderRadius: "12px",
      padding: "20px",
      boxShadow: "0 6px 12px rgba(0,0,0,0.3)",
      fontSize: "clamp(1rem, 2.5vw, 1.2rem)"
    },
    input: {
      marginTop: "10px",
      padding: "8px",
      border: "none",
      borderRadius: "5px",
      width: "100%",
      fontSize: "1rem",
      color:"black"
    },
    button: {
      padding: "12px 20px",
      marginTop: "20px",
      fontSize: "clamp(1rem, 3vw, 1.2rem)",
      background: "#ff8f00",
      border: "none",
      color: "white",
      borderRadius: "10px",
      cursor: "pointer",
    },
    result: {
      marginTop: "30px",
      fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
      textAlign: "center",
      color: "#ffcc80",
    },
    center: {
      textAlign: "center",
    }
  };

  return (
    <div style={styles.body}>
      <div style={styles.overlay}>
        <h1 style={styles.heading}>🎟️ Magic Mall Markdown</h1>
        <div style={styles.itemContainer}>
          {items.map((item, index) => (
            <div key={index} style={styles.item}>
              <strong style={{ color:"yellow" }}  >{item.name}</strong><br />
              Original Price: ${item.price}<br />
              Discount Spell: {item.discount}% off<br />
              Final Price: <input
                type="number"
                step="0.01"
                value={inputs[index]}
                onChange={(e) => handleInputChange(e.target.value, index)}
                style={styles.input}
              />
            </div>
          ))}
        </div>
        <div style={styles.center}>
          <button onClick={checkAnswers} style={styles.button}>Check Answers</button>
          <div style={styles.result} dangerouslySetInnerHTML={{ __html: result }} />
          {showNext && (
            <button onClick={generateScenario} style={styles.button}>Next Spell ➡</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MagicMallMarkdown;
